import type { InvestorMetricWindow } from '@/lib/investor-analytics';

const PERIOD_CONFIG = {
  '1W': { window: '7d', days: 7, interval: '1d' },
  '1M': { window: '30d', days: 30, interval: '1d' },
  '3M': { window: '90d', days: 90, interval: '1d' },
  '6M': { window: '180d', days: 180, interval: '1d' },
  YTD: { window: 'ytd', days: 'ytd', interval: '1d' },
  '1Y': { window: '365d', days: 365, interval: '1d' },
  // Inception is the one unbounded range: weekly is a deliberate payload
  // bound there, not an interval-by-range rule — bounded windows are daily.
  All: { window: 'inception', days: null, interval: '1w' }
} as const satisfies Record<
  string,
  {
    window: InvestorMetricWindow;
    days: number | 'ytd' | null;
    interval: '1d' | '1w';
  }
>;

export type PortfolioPeriod = keyof typeof PERIOD_CONFIG;

interface PortfolioPeriodQuery {
  window: InvestorMetricWindow;
  interval: '1d' | '1w';
  from?: string;
  to?: string;
}

export function getPeriodQuery(
  period: PortfolioPeriod,
  now = new Date()
): PortfolioPeriodQuery {
  const config = PERIOD_CONFIG[period];
  if (config.days == null) {
    return { window: config.window, interval: config.interval };
  }

  const to = new Date(now);
  const from = new Date(to);
  if (config.days === 'ytd') {
    from.setUTCMonth(0, 1);
  } else {
    from.setUTCDate(from.getUTCDate() - config.days);
  }
  return {
    window: config.window,
    interval: config.interval,
    from: from.toISOString().slice(0, 10),
    to: to.toISOString().slice(0, 10)
  };
}
